import { InvoicePaymentCollection, PartialInvoicePaymentCollection } from "@auer-steel/Services/InvoicePaymentService";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import addWishList from "@insite/client-framework/Store/Pages/MyLists/Handlers/AddWishList";
import translate from "@insite/client-framework/Translate";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable, { DataTableProps, SortOrderOptions } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import { DataTableCellBaseProps } from "@insite/mobius/DataTable/DataTableCellBase";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow, { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    partialInvoicePaymentCollection: any[];
    invoicePaymentCollection: InvoicePaymentCollection;
    onCancel: () => void;
    onSubmit: (partialInvoicePayments: PartialInvoicePaymentCollection[]) => void;
}

const mapDispatchToProps = {};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface PayInvoiceReasonFormStyles {
    container?: GridContainerProps;
    buttonsGridItem?: GridItemProps;
    reasonTextField?: TextFieldProps;
    cancelButton?: ButtonPresentationProps;
    saveButton?: ButtonPresentationProps;
    table?: DataTableProps;
    invoiceAmountHeader?: DataTableHeaderProps;
    payAmountHeader?: DataTableHeaderProps;
    invoiceAmountCell?: DataTableCellBaseProps;
    payAmountCell?: DataTableCellBaseProps;
    reasonErrorStyle?: TypographyProps;
}

export const payInvoiceReasonFormStyles: PayInvoiceReasonFormStyles = {
    container: {
        css: css`
        justify-content: center;
    `
    },
    buttonsGridItem: {
        width: 12,
        css: css`
            justify-content: center;
            margin-top: 20px !important;
        `
    },
    reasonTextField: {
        css: css`
        margin-top: 5px;
        margin-bottom: 2px;
        `
    },
    cancelButton: {
        color: "secondary",
        css: css`
            margin-right: 10px;
        `
    },
    table: {
        css: css`
        margin-top: 20px;
        `
    },
    invoiceAmountHeader: {
        css: css`
        text-align: right;
        `
    },
    payAmountHeader: {
        css: css`
        text-align: right;
        `
    },
    invoiceAmountCell: {
        css: css`
        text-align: right;
        `
    },
    payAmountCell: {
        css: css`
        text-align: right;
        `
    },
    reasonErrorStyle: {
        css: css`
        display: block;
        margin-top: 2px;
        `
    }
};

const styles = payInvoiceReasonFormStyles;
let isAnyReasonEmpty: boolean;

class PayInvoiceReason extends React.Component<Props> {
    submitHandler = (e: any) => {
        const partialInvoicePayments: PartialInvoicePaymentCollection[] = [];
        isAnyReasonEmpty = false;

        this.props.invoicePaymentCollection.invoicePayments.forEach(invoicePayment => {
            const invoice = this.props.partialInvoicePaymentCollection.filter(partialInvoicePayment => partialInvoicePayment.InvoiceNumber === invoicePayment.invoice.invoiceNumber);
            if (invoice && invoice.length > 0){
                const reason = document.querySelector(`#txt_invoice_${invoicePayment.invoice.invoiceNumber}`) as any;
                const reasonError = document.querySelector(`#txt_invoice_${invoicePayment.invoice.invoiceNumber}_error`) as any;
                if (reason && reason.value && reason.value.trim()) {
                    reasonError.innerText = "";
                    partialInvoicePayments.push({
                        InvoiceNumber: invoicePayment.invoice.invoiceNumber,
                        Reason: reason.value
                    });
                }
                else{
                    reasonError.innerText = siteMessage("Pay_Invoice_Reason_Required");
                    if (!isAnyReasonEmpty) {
                        isAnyReasonEmpty = true;
                    }
                }
            }
        });

        if(!isAnyReasonEmpty){
            this.props.onSubmit(partialInvoicePayments);
        }
    };

    render() {
        return (
            <StyledWrapper>
                <span>{`${siteMessage("Pay_Invoice_Reason_Modal_SubHeader")}`}</span>
                <DataTable {...styles.table}>
                    <DataTableHead>
                        <DataTableHeader>
                            {translate("Invoice #")}
                        </DataTableHeader>
                        <DataTableHeader {...styles.invoiceAmountHeader}>
                            {translate("Invoice Amount")}
                        </DataTableHeader>
                        <DataTableHeader {...styles.payAmountHeader}>
                            {translate("Pay Amount")}
                        </DataTableHeader>
                        <DataTableHeader>
                            {translate("Reason *")}
                        </DataTableHeader>
                    </DataTableHead>
                    <DataTableBody>
                        {this.props.partialInvoicePaymentCollection.map(
                            ({
                                InvoiceNumber,
                                CurrentBalance,
                                PayAmount
                            }) => (
                                <DataTableRow key={InvoiceNumber}>
                                    <DataTableCell>
                                        {InvoiceNumber}
                                    </DataTableCell>
                                    <DataTableCell {...styles.invoiceAmountCell}>
                                        {CurrentBalance}
                                    </DataTableCell>
                                    <DataTableCell {...styles.payAmountCell}>
                                        {PayAmount}
                                    </DataTableCell>
                                    <DataTableCell>
                                        <TextField id={`txt_invoice_${InvoiceNumber}`} {...styles.reasonTextField}></TextField>
                                        <Typography id={`txt_invoice_${InvoiceNumber}_error`} size="secondary" color="danger" weight={600} {...styles.reasonErrorStyle}></Typography>
                                    </DataTableCell>
                                </DataTableRow>
                            ),
                        )}
                    </DataTableBody>
                </DataTable>
                <GridContainer {...styles.container}>
                    <GridItem {...styles.buttonsGridItem}>
                        <Button {...styles.cancelButton} onClick={this.props.onCancel}>
                            {translate("Cancel")}
                        </Button>
                        <Button {...styles.saveButton} onClick={this.submitHandler}>
                            {translate("Save")}
                        </Button>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
        );
    }
}

export default connect(null, mapDispatchToProps)(PayInvoiceReason);